export default __webpack_public_path__ + "static/media/info.ac807f5e.svg";